import { render, staticRenderFns } from "./Testimonial.vue?vue&type=template&id=55c7b8b5&"
import script from "./Testimonial.vue?vue&type=script&lang=js&"
export * from "./Testimonial.vue?vue&type=script&lang=js&"
import style0 from "./Testimonial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCardImg, BCardTitle, BCardText, BCard} from 'bootstrap-vue'
    installComponents(component, {BCardImg, BCardTitle, BCardText, BCard})
    

export default component.exports